<template>
    <div class="body">
            <p  class="font1" style="padding-top: 8vh;color: #e06c24;">卓越进取，成就非凡</p>
            
            <p class="font2" style="padding-top: 2vh;">2024上半年你在富学宝典的学习成就:</p>
            <div>
                <div class="list">
                    <p class="font2">学习课程<a class="font3">{{ ReportData.coursenumMon }}</a>门</p>
                </div>
                <div class="list">
                    <p class="font2">获得学分<a class="font3">{{ ReportData.creditvalueFxbd }}</a>个</p>
                </div>
                <p class="font2" style="padding-top: 2vh;">超越了<a class="font3">{{ ReportData.rate2 }}%</a>同行小伙伴！</p>
                <p class="font2" style="padding-top: 4vh;margin: 0;">每一次超越都是对自己极限的突破</p>
                <p class="font2" style="margin: 0;">继续前行，你的潜力无限</p>
            </div>
            

            
    </div>
</template>


<script>
export default {
      props: ["ReportData"],
      data() {
        return {
        }
      },
    }
</script>
  
<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24June/logo.png") right  top  no-repeat,
                url("../../assets/24June/bg1.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
.list{
    display: flex;
    justify-content: center; 
    align-items: center; 
    width: 70%;
    /* padding-left: 8%; */
    height: 7vh;
    margin: 0;
    margin-left: 8%;
    background-color: #cd8b52;
    margin-top: 1vh;
    border-radius: 10px;
    border: #fff solid 1px;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 18px;
    color: #000;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    padding-left: 8%;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.fa{
    color:rgb(206, 144, 28);
    align-items: center;
}
.AddNumber-com {
    font-size: 30px;
    font-weight: bold;
    color: orange;
}
</style>